module.exports = __webpack_public_path__ + "img/diploma.15541014.svg";